// Central storefront config — single source of truth.
export const API_BASE = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
export const apiUrl = (path) => `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;

// Shipping (server mirrors in lib/quote.js shippingFor — keep in sync):
// free within India; international orders under the threshold pay a flat
// insured fee.
export const FREE_SHIPPING_THRESHOLD = 1000;
export const INTL_SHIPPING_USD = 25;
export const shippingFor = (countryCode, totalAfterDiscount) =>
  !countryCode || countryCode === 'IN' || totalAfterDiscount >= FREE_SHIPPING_THRESHOLD ? 0 : INTL_SHIPPING_USD;

// One dispatch time for every piece, gold and silver.
export const DISPATCH_TEXT = 'Handcrafted to order · Dispatches in 12–14 business days';
export const DISPATCH_DAYS = '12–14 business days';

// Whole-cart quantity cap (total units across all lines). Breaching it sends
// the shopper to the Contact page for a bulk/seller inquiry. Server mirrors
// this in quoteCart — keep the two in sync.
export const MAX_CART_QTY = 5;

// The one certification claim the storefront makes (Merchant Center checks
// claims against what ships): only 1 ct+ center diamonds carry an IGI report.
export const IGI_CENTER_TEXT = 'IGI certificate for center diamonds 1 ct & above';

export const CONTACT = {
  phone: '+91 9725756046',
  phoneHref: 'tel:+919725756046',
  email: 'etherstarjewels@gmail.com',
  whatsapp: '+91 9725756046',
  // Must match Business info in Google Merchant Center exactly.
  address: 'D-1003, Om Heritage, Ved Road, Katargam, Surat, Gujarat 395004, India',
};
